<template>
  <v-form ref="form" v-model="valid">
    <v-container fluid>
      <nav>
        <v-app-bar app>
          <v-toolbar-title><v-breadcrumbs :items="items" large></v-breadcrumbs></v-toolbar-title>
        </v-app-bar>
      </nav>

      <v-card-title>General</v-card-title>
      <v-card>
        <v-row>
          <v-col cols="2">
            <v-subheader>SMP Console S/N</v-subheader>
          </v-col>
          <v-col cols="2">
            <v-select
              :items="serialNumber"
              item-value="serialNumber"
              :item-text="
                (serialNumber) => {
                  return serialNumber.serialNumber;
                }
              "
              v-model="smp[0].consoleSn"
              label="Serial Number*"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>SMP Console Label</v-subheader>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="smp[0].consoleId" disabled> </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Location Name</v-subheader>
          </v-col>
          <v-col cols="2">
            <v-select
              :items="locationItem"
              item-value="_id"
              :item-text="
                (locationItem) => {
                  return locationItem.location;
                }
              "
              v-model="smp[0].locationName"
              label="Location*"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card>

      <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-container>
  </v-form>
</template>

<script>
  import axios from "axios";
  import router from "../../router";

  export default {
    data() {
      return {
        items: [
          {
            text: "Dashboard",
            disabled: false,
            href: "/",
          },
          {
            text: "Settings",
            disabled: true,
            href: "",
          },
          {
            text: "Seismic",
            disabled: false,
            href: "/smp-data",
          },
          {
            text: "Edit",
            disabled: true,
            href: "",
          },
        ],
        smp: [],

        valid: true,
        serialNumber: [],
        locationItem: [],
        showDeleteDialog: false,
      };
    },
    created() {
      this.loadsSerialNumber();
      this.loadsLocation();
      this.loadsSmp();
    },
    methods: {
      loadsSmp: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smp-data/" + this.$route.params.id;
        axios
          .get(apiURL)
          .then((res) => {
            this.smp = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsLocation: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/location";
        axios
          .get(apiURL)
          .then((res) => {
            this.locationItem = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsSerialNumber: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/serial-number-smp";

        try {
          const response = await axios.get(apiURL);
          const filteredSerialNumbers = response.data.filter((item) => /^0001\d{3}[3-5]\d$/.test(item.serialNumber));
          this.serialNumber = filteredSerialNumbers;
        } catch (error) {
          console.log(error);
        }
      },
      async saveItem() {
        if (this.$refs.form.validate()) {
          let apiURL = process.env.VUE_APP_API + "/api/update-smp-data/" + this.$route.params.id;
          axios.post(apiURL, {
            consoleSn: this.smp[0].consoleSn,
            consoleId: this.smp[0].consoleId,
            locationName: this.smp[0].locationName,
            modifiedBy: this.$keycloak.tokenParsed.given_name,
          });
        }
        router.go(-1);
      },
    },
  };
</script>
